// main.js

import { Accordion } from "./components/accordion.js";
import { initContentAccordion } from "./components/content-accordion.js";
import { initNavDropdown } from "./components/nav-dropdown.js";
import { initNavigationDrawer } from "./components/navigation-drawer.js";
import { initThemeToggle } from "./components/theme-toggle.js";
import { initDataVideoElements } from "./components/data-video-elements.js";
import { initGallerySlider } from "./components/gallery-slider.js";
import { initMediaGallery } from "./components/media-gallery.js";
import { initSearch } from "./components/search.js";
import { initSiteLoader } from "./components/site-loader.js";
import { testimonial } from "./components/testimonial.js";
import { logoSlider } from "./components/logo-slider.js";
import { initThreeColCardsSlider } from "./components/three-col-cards.js";
import { initSponsorsSlider } from "./components/sponsors-slider.js";
// import { bannerClip } from "./components/bannerClip.js";
import { initBannerHeroVideoCutout } from "./components/banner-hero-cutout.js";
import { siteHeader } from "./components/siteHeader.js";
import { initProductCardSlider } from "./components/product-card-slider.js";
import { initEventCountdown } from "./components/event-countdown.js";
import { initDatesHours } from "./components/dates-hours.js";
import { initFullWidthImageVideo } from "./components/full-width-image-video.js";
import { initQuickLinks } from "./components/quick-links.js";
import { initColumGridWithHoverSlider } from "./components/colum-grid-with-hover.js";
import { initContactTabs } from "./components/contact-tabs.js";
import lenis from "./components/lenis.js";
import { initTabsSticky } from "./components/tabs-sticky.js";
import { initSpeakerSlider } from "./components/speaker-slider.js";
import { initAgenda } from "./components/agenda.js";
import { initImgColGrid } from "./components/img-col-grid.js";
import { initNewsInsightsSlider } from "./components/news-insights-slider.js";
import { initTwoColSection } from "./components/two-col-section.js";
import { initVideoTestimonial } from "./components/video-testimonial.js";
import { downArrowScript } from "./components/downArrowScript.js";
import { initChartCards } from "./components/chart-cards.js";
import { initDeviceBrowserClasses } from "./utils/device-browser-classes.js";

initDeviceBrowserClasses();
initSiteLoader();

document.addEventListener("DOMContentLoaded", () => {
  lenis();
  initEventCountdown();
  initDatesHours();
  Accordion();
  initContentAccordion();
  initNavDropdown();
  initNavigationDrawer();
  // textBgVideo();
  initThemeToggle();
  initDataVideoElements();
  initFullWidthImageVideo();
  initGallerySlider();
  initMediaGallery();
  initSearch();
  testimonial();
  logoSlider();
  initThreeColCardsSlider();
  initSpeakerSlider();
  initSponsorsSlider();
  // bannerClip();
  initBannerHeroVideoCutout();
  siteHeader();
  initProductCardSlider();
  initQuickLinks();
  initColumGridWithHoverSlider();
  initContactTabs();
  initTabsSticky();
  initAgenda();
  initImgColGrid();
  initNewsInsightsSlider();
  initTwoColSection();
  initVideoTestimonial();
  downArrowScript();
  initChartCards();
});